import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiQuery, QueryPart, QueryPartStrategy } from '@stylehaven/components';
import { map, switchMap } from 'rxjs/operators';
import { ExecutionEntity } from '../../entities/execution/execution.entity';
import { LuceneHelper } from '../../helpers';
import { ApiFragment } from '../../record/entities/api-fragment.entity';
import { DottedKey } from '../../record/entities/metadata-field.entity';
import { RecordStatus } from '../../record/entities/record-status.type';
import { RecordService } from '../../record/services/record.service';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class ExecutionService {
    private readonly ENDPOINT = 'executions';
    constructor(
        private readonly http: AbstractHttpService,
        private recordService: RecordService,
        private luceneHelper: LuceneHelper
    ) {}

    startExecution(execution: ExecutionEntity): Observable<void> {
        return this.http.post<void>(`${this.ENDPOINT}`, execution);
    }

    storePackagingUnits(location: ApiFragment, packagingUnits: ApiFragment[]): Observable<void> {
        return this.startExecution({
            ProcessName: 'depot_store_packaging_units',
            Properties: {
                LocationId: location!.getRecordId(),
                RecordIds: packagingUnits.map(pu => pu.getRecordId())
            }
        }).pipe(switchMap(() => this.syncRecords(packagingUnits).pipe(map(() => undefined))));
    }

    private syncRecords(packagingUnits: ApiFragment[]): Observable<number> {
        return this.recordService.waitForRecordCountIndex({
            search: {
                Q: this.luceneHelper.queryToLuceneQuery(
                    new ApiQuery([
                        new QueryPart({
                            field: DottedKey.RecordId,
                            values: packagingUnits.map(record => record.getMediaObjectId()),
                            strategy: QueryPartStrategy.MatchAtLeastOne
                        }),
                        new QueryPart({
                            field: DottedKey.RecordStatus,
                            values: [RecordStatus.InDepot, RecordStatus.Requested],
                            strategy: QueryPartStrategy.MatchAtLeastOne
                        })
                    ])
                )
            },
            predicate: amount => amount === packagingUnits.length
        });
    }
}
